// src/data/exercises/L4_04.js

const accountOptions = [
  '現金', '前受金', '当座預金', '前払金', '仕入'];

export const L4_04 = {
  title: '簿記　3級（第212-4回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
    parts: [
    { "type": "ruby", "text": "千葉商事株式会社", "ruby": "ちばしょうじかぶしきがいしゃ" },
    { "type": "text", "value": "と" },
    { "type": "ruby", "text": "商品購入", "ruby": "しょうひんこうにゅう" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "契約", "ruby": "けいやく" },
    { "type": "text", "value": "を" },
    { "type": "ruby", "text": "結", "ruby": "むす" },
    { "type": "text", "value": "び、" },
    { "type": "ruby", "text": "内金", "ruby": "うちきん" },
    { "type": "text", "value": "￥300,000について" },
    { "type": "ruby", "text": "小切手", "ruby": "こぎって" },
    { "type": "text", "value": "を" },
    { "type": "ruby", "text": "振", "ruby": "ふ" },
    { "type": "text", "value": "り" },
    { "type": "ruby", "text": "出", "ruby": "だ" },
    { "type": "text", "value": "して" },
    { "type": "ruby", "text": "支払", "ruby": "しはら" },
    { "type": "text", "value": "った。" }
],
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '前払金', debitAmount: 300000, creditAccount: '当座預金', creditAmount: 300000},
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '①まず、一番大切なのは小切手で支払ったので\n' },
          { type: 'text', value: '当座預金が減少（マイナス）します。\n' },
          { type: 'styled', value: '当座預金の減少（マイナス）は、貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②次に、商品購入（仕入）の前に内金（お金）を払う。\n' },
          { type: 'text', value: '内金を払うとあるので、内金を払うときは前払金が増加（プラス）します。\n' },
          { type: 'styled', value: '前払金の増加（プラス）は、借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`①まず、一番大切なのは小切手で支払ったので
当座預金が減少（マイナス）します。

次に、商品購入（仕入）の前に内金（お金）を払う。
内金を払うとあるので、内金を払うときは前払金が増加（プラス）します。


`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
           parts: [
          { type: 'text', value: '①まず、一番大切なのは小切手で支払ったので\n' },
          { type: 'text', value: '当座預金が減少（マイナス）します。\n' },
          { type: 'styled', value: '当座預金の減少（マイナス）は、貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '②次に、商品購入（仕入）の前に内金（お金）を払う。\n' },
          { type: 'text', value: '内金を払うとあるので、内金を払うときは前払金が増加（プラス）します。\n' },
          { type: 'styled', value: '前払金の増加（プラス）は、借方（左・Ｄｒ）に記入します。', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};